// #region imports

// --- Angular
import { Component, OnInit, Input, Output, ChangeDetectionStrategy, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

// --- HS Code
import { SurveyStatuses, ResultsStatuses } from '../../../models';
import { environment } from '../../../../environments/environment';

// #endregion

@Component({
  selector: 'hs-survey-widget-buttons',
  templateUrl: './survey-widget-buttons.component.html',
  styleUrls: ['./survey-widget-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SurveyWidgetButtonsComponent implements OnInit, OnChanges {
  @Input() selfProgress: SurveyStatuses = SurveyStatuses.notStarted;
  @Input() surveyType: number = 0; // ToDo: Actually do something useful with surveyType
  @Input() surveyStatus: SurveyStatuses | undefined;
  @Input() surveyId: string | undefined;
  @Input() disabled: boolean = false;
  @Input() reportIsLoading: boolean = false;
  @Input() reportIsDownLoading: boolean = false;
  @Input() updated: Date | undefined;
  @Input() hasReport: boolean = false;
  @Input() isLocked: boolean = false;
  @Input() resultsStatus: ResultsStatuses = ResultsStatuses.surveyIncomplete;

  @Output() buttonClick = new EventEmitter();

  viewReportBase: string = '';

  resultsStatuses = ResultsStatuses;
  surveyStatuses = SurveyStatuses;

  constructor() { }

  ngOnInit() {
    this.viewReportBase = environment.apiConfig.apiUrl + environment.apiConfig.reportsApi + '/';
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  onWidgetButtonClick(buttonId: string): void {
    this.buttonClick.emit(buttonId);
  }
}
